import { useQuery, UseQueryResult } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { STALE_QUERY_TIMEOUT_MSEC } from "./constants";
import { eventQueryKeys } from "./eventQueryKeys";

export function useEventTags(orgId: string): UseQueryResult<string[], Error> {
  const { events } = useDomainServices();

  return useQuery({
    queryKey: eventQueryKeys.orgTags(orgId),
    queryFn: ({ signal }) => {
      // Callers needing truncation info call the service directly.
      return events
        .getTagsForOrg(
          {},
          {
            abortSignal: signal,
            resourceOwnerId: orgId,
          },
        )
        .then((page) => page.items);
    },
    staleTime: STALE_QUERY_TIMEOUT_MSEC,
  });
}
